import { MiddlewareConsumer, Module } from '@nestjs/common';
import { DatacollectorController } from './datacollector.controller';
import { DataCollectorService } from './services/datacollector.service';
import { DDMService } from './services/ddm.service';
import { SchedulerService } from './services/scheduler.service';
import { RRDService } from './services/rrd_database.service';
import { DeviceService } from './services/device.service';
import { ContextMiddleware, ServerAuthModule } from '@ip6m/server/auth';
import { EthernetStatusService } from './services/ethernet-status.service';
import { ServerFeatureConfigurationModule } from '@ip6m/server/feature-configuration';

@Module({
  controllers: [DatacollectorController],
  providers: [
    DataCollectorService,
    DeviceService,
    SchedulerService,
    DatacollectorController,
    DDMService,
    RRDService,
    EthernetStatusService
  ],
  imports: [
    ServerAuthModule,
    ServerFeatureConfigurationModule],
  exports: [
    DeviceService
  ]
})
export class DatacollectorModule {
  configure(consumer: MiddlewareConsumer): void {
    consumer.apply(ContextMiddleware).forRoutes(DatacollectorController);
  }
}
